import { AfterContentChecked, Component, ElementRef, EventEmitter, Input, NgModule, Output, Renderer2, ViewChild } from '@angular/core';
import { CreateControlAccessProvider, getOptionValue } from '@wipo/w-angular/shared';
import { FFacetInfoModule } from '@wipo/w-angular/internal';
import { WInputBase } from '@wipo/w-angular/shared';

import { CommonModule } from '@angular/common';
import { WOption } from '@wipo/w-angular/shared';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'w-select-one',
  templateUrl: './w-select-one.component.html',
  providers: [CreateControlAccessProvider(WSelectOneComponent)],
  host: {
    class: 'b-input b-input-select-one b-input-dropdown',
    '[class.b-input--has-content]': 'hasContent',
    '[class.b-input--has-label]': 'hasLabel',
    '[class.b-input--has-floating-label]': 'hasLabel'
  },
  standalone: false
})
/*
@id w-select-one
@name w-select-one
@status release
@description
@hidden [placeholder] # hide parent attribute from documentation
*/
export class WSelectOneComponent extends WInputBase implements AfterContentChecked {
  @ViewChild('sel', { static: true }) selectElement!: ElementRef<HTMLSelectElement>;
  @Input() options: (WOption | string)[] = [];
  @Input() unselectLabel?: string;
  @Output() wSelect = new EventEmitter<any>(); // emits value of the selected Option
  focused: boolean = false;
  _title_selected: string = '';
  get hasLabel() {
    return !!this.label;
  }
  get hasContent() {
    return (!this.noneSelected || this.unselectLabel || this.focused || (this.placeholder && !this.label));
  }
  get canUnselect() {
    return this.unselectLabel !== undefined;
  }
  get noneSelected() {
    try {
      return !this.options || this.value === undefined || !this.options.find(o => this.value === getOptionValue(o));
    } catch (e) {
      console.error('get@noneSelected', e);
    }
    return true;
  }
  get selectedOption() {
    const idx = this.selectElement.nativeElement.options.selectedIndex;
    return this.options?.[idx - 1];
  }
  /** override parent tooltip (title only) */
  override get tooltip() {
    return this.title || this._title_selected;
  }

  // tslint:disable-next-line: variable-name
  constructor(protected _renderer: Renderer2, protected _elementRef: ElementRef) {
    super();
  }
  ngAfterContentChecked(): void {
    const title = this.getTitle(this.selectedOption);
    if (this._title_selected !== title) {
      setTimeout(() => this._title_selected = title);
    }
  }
  getTitle(option: WOption | string) {
    if (!option) {
      // nothing selected, return empty string
      return '';
    } else if (typeof option === 'string') {
      return this.attr(option);
    } else {
      // if we use WOption array, we can set title for each option
      return this.attr(option?.tip);
    }
  }
  getDisabled(option: WOption | string) {
    if (typeof option === 'string') {
      return undefined;
    } else {
      return this.attr(option?.disabled);
    }
  }
  isSelected(option: WOption | string) {
    const iss = this.getValue(option) === this.value;
    if (iss) {
      // IE workaround, touch options to make sure browser refreshes the option list
      const noop = this.selectElement.nativeElement.options.length;
      if (noop > this.options.length + 1) {
        console.log('SEL', option, 'wrong/double options length:', noop, 'options length:', this.options.length);
      }
    }
    return iss;
  }
  selected(event: Event) {
    const select = event.target as HTMLSelectElement;
    // first in list is the invisible default entry, not on the list (so -1)
    const selectedOption = this.options[select.options.selectedIndex - 1];
    this.value = getOptionValue(selectedOption);
    this.wSelect.emit(this.value);
  }
}

@NgModule({
  imports: [CommonModule, FormsModule, FFacetInfoModule],
  exports: [WSelectOneComponent],
  declarations: [WSelectOneComponent]
})
export class WSelectOneModule { }